export default __webpack_public_path__ + "static/media/arctradeLogo_icon_dark.0b406ba1.png";